// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const LockClosedIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 12 16">
    <path
      fill="currentColor"
      d="M10.34 6.09h-.32V4.2C10.02 1.88 8.22 0 6 0a4.1 4.1 0 0 0-4.02 4.2v1.89h-.32A1.7 1.7 0 0 0 0 7.83v6.43C0 15.22.74 16 1.66 16h8.68A1.7 1.7 0 0 0 12 14.26V7.83a1.7 1.7 0 0 0-1.66-1.74M2.8 4.2A3.3 3.3 0 0 1 6 .85c1.76 0 3.2 1.5 3.2 3.35v1.89h-.79V4.2c0-1.4-1.08-2.52-2.41-2.52A2.47 2.47 0 0 0 3.59 4.2v1.89H2.8zm4.8 1.89H4.4V4.2c0-.92.72-1.67 1.6-1.67s1.6.75 1.6 1.67zm3.59 8.17c0 .5-.38.89-.85.89H1.66a.87.87 0 0 1-.85-.89V7.83c0-.5.38-.89.85-.89h8.68c.47 0 .85.4.85.89zM6 8.51c-.8 0-1.46.69-1.46 1.53 0 .42.16.82.45 1.1v1.38c0 .59.45 1.06 1 1.06.57 0 1.02-.47 1.02-1.06v-1.38c.28-.28.45-.68.45-1.1A1.5 1.5 0 0 0 6 8.5m.37 2.08a.4.4 0 0 0-.17.35v1.58a.2.2 0 0 1-.2.2.2.2 0 0 1-.2-.2v-1.58a.4.4 0 0 0-.17-.35.7.7 0 0 1-.28-.55c0-.37.3-.68.65-.68s.65.3.65.68q0 .35-.28.55"
    />
  </svg>,
  "LockClosed",
);
export default LockClosedIcon;
